import { Dispatch } from 'redux';
import {
  LOAN_PURPOSE,
  // CLEAR_STATE,
  CARD_PURPOSE,
  DOCUMENT_UPLOAD,
  LOAN_PURPOSE_ADDITIONAL,
  CARD_PURPOSE_ADDITIONAL_INFO,
  CLEAR_DOCUMENT_UPLOAD,
  SET_HOME_ADDRESS_REQUEST_STATUS,
} from '~/actions/actionTypes';
import {
  getErrorMessage,
  IErrorMessages,
  IErrorWithValidation,
} from '~/services/ErrorMessageService';
// import { createComponentState } from '~/services/StateService';
import { IDocumentUploadState } from '~/sharedInterfaces/IState';
import { ICombinedTranslations } from '~/translations';
import { setInvalidError } from './errorActions';

export const setInput = (type: string, value: string | boolean) => ({
  type,
  payload: value,
});

export const setLoanPurpose = (purpose: string) => ({
  type: LOAN_PURPOSE,
  payload: purpose,
});

export const setCardPurpose = (purpose: string) => ({
  type: CARD_PURPOSE,
  payload: purpose,
});

export const setLoanPurposeAdditionalInfo = (additionalInfo: string) => ({
  type: LOAN_PURPOSE_ADDITIONAL,
  payload: additionalInfo,
});

export const setCardPurposeAdditionalInfo = (additionalInfo: string | null) => ({
  type: CARD_PURPOSE_ADDITIONAL_INFO,
  payload: additionalInfo,
});

export const setDocumentUploadFiles = (files: IDocumentUploadState[]) => ({
  type: DOCUMENT_UPLOAD,
  payload: files,
});

export const clearDocumentUpload = () => ({
  type: CLEAR_DOCUMENT_UPLOAD,
});

export const validateValue = (
  validatorFunction: (value: string | number, market?: string) => boolean,
  componentName: string,
  value: string | number,
  locale: keyof ICombinedTranslations
) => {
  return (dispatch: Dispatch) => {
    const market = locale.split('-')[1];
    const valid = validatorFunction(value, market);

    if (valid || !value) dispatch(setInvalidError(componentName, ''));
    else if (value) {
      const { invalid } = getErrorMessage(
        locale,
        componentName as keyof IErrorMessages
      ) as IErrorWithValidation;
      dispatch(setInvalidError(componentName, invalid));
    }
  };
};

export const setHomeAddressRequestStatus = (status: string) => ({
  type: SET_HOME_ADDRESS_REQUEST_STATUS,
  payload: status,
});

// Not used atm, but the intention was to use this if we do step 1 submit without redirect
// TODO: fix this to make it just get the components from the first stage
// export const clearFormState = () => {
//   return (dispatch: Dispatch, getState: () => IState) => {
//     const {
//       widgetContext: { pages },
//     } = getState();

//     const componentsInInitialState = createComponentState(pages);
//     dispatch({
//       type: CLEAR_STATE,
//       payload: componentsInInitialState,
//     });
//   };
// };
